import script from "./sw-item-viewer-fullname.vue?vue&type=script&setup=true&lang=js"
export * from "./sw-item-viewer-fullname.vue?vue&type=script&setup=true&lang=js"

import "./sw-item-viewer-fullname.vue?vue&type=style&index=0&id=d1658552&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d1658552"]])

export default __exports__